import React, { useCallback, useState } from "react";
import "./styles.css"; // Include your styles here or use inline styles
import { Button, Grid, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import Strings from "../../../Config/Strings";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";
import CustomButton from "../../../Components/CustomButton";
import Loader from "../../../Components/Loader";
import { useDispatch } from "react-redux";
import {
  loginUserAPI,
  registerUserAPI,
} from "../../../Store/Action/authAction";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { phoneSchema } from "../../../Services/ValidationSchema";
import Icons from "../../../Config/Images";
import ReCAPTCHA from "react-google-recaptcha";

const Login = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(phoneSchema),
  });

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onChange = (value) => {};

  const onSubmit = async (data) => {
    const userRequestData = {
      user_mobile_number: data?.mobileNo,
    };
    setLoading(true);
    try {
      // await dispatch(
      //   loginUserAPI(userRequestData, (isSuccess, response) => {
      //     setLoading(false);
      //     if (isSuccess?.status === true) {
      //       toast.success(
      //         response?.data?.message || "OTP sent your registered mobile no."
      //       );
      //       navigate("/otpVerification");
      //     } else {
      //       const errorMessage =
      //         response?.error?.message || Strings.somethingWentWrongError;
      //       toast.error(errorMessage);
      //     }
      //   })
      // );
      await dispatch(
        registerUserAPI(userRequestData, (isSuccess, response) => {
          setLoading(false);
          if (isSuccess?.status === true) {
            toast.success(
              response?.data?.message || "OTP sent your registered mobile no."
            );
            navigate("/admin/otpVerification");
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div className="container">
      <div className="forms-container">
        <div
          style={{
            width: "77%",
            display: "flex",
            justifyContent: "end",
            marginTop: "90px",
          }}
        >
          <img
            src={Icons.loginIcon3}
            style={{ height: "28vh", width: "16vw", marginBottom: "20px" }}
            alt="login circle icon"
          />
        </div>

        <div style={rightSideView}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Typography style={mainHeadingStyle}>Login</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>
                  {Strings.mobileNoPlaceholder}
                </Typography>
                <Controller
                  name="mobileNo"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder={Strings.mobileNoPlaceholder}
                      variant="outlined"
                      fullWidth
                      error={!!errors.mobileNo}
                      helperText={
                        errors?.mobileNo ? errors?.mobileNo?.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                        maxLength: 10,
                      }}
                      inputProps={{
                        maxLength: 10,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={7}>
                <ReCAPTCHA
                  sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                  onChange={onChange}
                />
              </Grid>

              <CustomButton
                handleSubmit={handleSubmit}
                label={Strings.Submit}
              />
            </Grid>
          </form>
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <div className="content">
            <img
              src={Icons.loginCircle}
              className="animated-image"
              style={{ height: "25vh", width: "13vw", marginBottom: "20px" }}
              alt="login circle icon"
            />
            <h3 style={mediumTxtStyle}>New here?</h3>
            <p style={lightTxtStyle}>
              Not a member yet? Join our community to receive exclusive offers,
              updates, and access to our latest collections!
            </p>
          </div>
        </div>
      </div>

      <Loader loading={loading} />
    </div>
  );
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  marginTop: "20px",
  marginBottom: "20px",
  width: "100%",
  display: "flex",
};

const labelInfoStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.black,
  display: "flex",
  marginBottom: "5px",
};

const lightTxtStyle = {
  fontSize: 15,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.white,
  display: "flex",
  marginBottom: "5px",
};
const mediumTxtStyle = {
  fontSize: 20,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans,
  color: Colors.white,
  marginBottom: "5px",
};

const inputTextStyle = {
  fontSize: 14,
  fontWeight: "400",
  fontFamily: Fonts.NunitoSans,
  color: Colors.darkGray,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  backgroundColor: Colors.lightBlue,
  width: "30vw",
};

const rightSideView = {
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  left: "75%",
  width: "50%",
  transition: "1s 0.7s ease-in-out",
  display: "flex",
  zIndex: 5,
};

const signUpBtnStyle = {
  backgroundColor: "transparent",
  color: Colors.white,
  height: "43px",
  width: "12vh",
  borderRadius: "8px",
  border: "2px solid #ffff",
  fontSize: 14,
  fontWeight: "700",
  fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
  marginTop: "10px",
  "&:hover": {
    backgroundColor: Colors.white,
    color: Colors.black,
    border: "0px",
  },
  transition: "background-color 0.3s, color 0.3s",
};

export default Login;
